import { Image } from "@crystallize/reactjs-components";
import { ParagraphCollection } from "../components/crystallize-components/paragraph-collection";
import { RelatedDocument } from "../components/related-document";
import { Product } from "../components/item/product";
import { Story } from "../../use-cases/contracts/Story";
import { buildSchemaMarkupForBlogPost } from "~/use-cases/SchemaMarkupBuilder";
import { RichTextRenderer } from "~/ui/components/rich-text-renderer";

export default ({ data: story }: { data: Story }) => {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(buildSchemaMarkupForBlogPost(story)),
        }}
      />
      <div className="2xl md:container md:px-6 px-4 mx-auto mt-10 mb-6">
        <div>
          <a
            href="/blogg"
            className="pb-12 inline-block no-underline hover:underline"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 320 512"
              width={8}
              className="inline-block pb-1"
            >
              <path
                fill="#666"
                d="M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3
              256 246.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"
              />
            </svg>{" "}
            Tips og råd
          </a>

          <h1 className="text-4xl lg:text-6xl font-semibold mb-8">
            {story.title}
          </h1>
          <p className="mb-4 text-md">
            {new Date(story.createdAt).toLocaleString("no-NB", {
              year: "numeric",
              month: "long",
              day: "numeric",
            })}
          </p>
          <div className="w-full lg:w-3/4 max-w-[1000px] md:pr-5 my-2 text-xl leading-[1.6em]">
            <RichTextRenderer json={story.description.json} />
          </div>
        </div>
      </div>

      <div className="md:flex gap-6 lg:gap-9 xl:gap-14 md:container md:px-6 px-4 mx-auto mt-4 mb-6">
        <div>
          <div className="2xl mx-auto">
            <div className="max-w-[1000px] img-container overflow-hidden rounded-lg">
              <Image
                {...story.medias?.images?.[0]}
                sizes="100vw"
                fallbackAlt={story.title}
              />
            </div>
          </div>
          <div className="2xl mx-auto frntr-story">
            <div className="max-w-[1000px] ">
              {story.story && <ParagraphCollection paragraphs={story.story} />}
            </div>
          </div>
        </div>
        <div className="lg:w-1/4 md:w-2/5">
          {story.relatedArticles.length > 0 && (
            <div className="2xl mx-auto">
              <h3 className="text-sm pb-4 headerFiller text-[#666666]">
                Relaterte poster
              </h3>
              <div className="gap-5 grid md:flex grid-cols-2 sm:grid-cols-3 pb-5 flex-wrap">
                {story.relatedArticles?.map((item: any, index: number) => (
                  <div key={index}>
                    <RelatedDocument document={item} />
                  </div>
                ))}
              </div>
            </div>
          )}
          {story.featuredProducts.length > 0 && (
            <div className="2xl mx-auto">
              <h3 className="text-sm pb-4 headerFiller text-[#666666]">
                Relaterte produkter
              </h3>
              <div className="gap-5 grid md:flex grid-cols-2 sm:grid-cols-3 pb-5 flex-wrap">
                {story.featuredProducts?.map((item: any, index: number) => {
                  return <Product item={item} key={index} />;
                })}
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};
